import HighlightModel from '../highlight/index.model.js';
import RelevanceModel from '../relevance/index.model.js';
const model = {
    name: 'Query',
    properties: {
        highlight: { type: 'model', model: HighlightModel },
        keyphrase: { required: true },
        operator: {},
        relevance: { type: 'array', model: RelevanceModel },
    },
};
export default model;
